import { Group, Text, ThemeIcon, UnstyledButton, useComputedColorScheme } from '@mantine/core';
import { ReactNode } from 'react';

type GetStartedItemProps = {
    icon: ReactNode;
    title: string;
    subtitle: string;
    onClick: () => void;
};

/**
 * One action card in the "Get Started" modal. Extracted because this markup was
 * previously copy-pasted once per action.
 */
const GetStartedItem = ({ icon, title, subtitle, onClick }: GetStartedItemProps) => {
    const scheme = useComputedColorScheme('light');

    return (
        <UnstyledButton
            onClick={onClick}
            style={{
                padding: '16px 20px',
                borderRadius: 12,
                background: scheme === 'dark' ? '#000' : '#fff',
                border: `2px solid ${scheme === 'dark' ? '#5c5f66' : '#ced4da'}`,
                color: scheme === 'dark' ? '#FFF' : '#000',
                transition: 'box-shadow 160ms ease',
            }}
            onMouseEnter={e => {
                (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 18px rgba(0, 0, 0, 0.18)';
            }}
            onMouseLeave={e => {
                (e.currentTarget as HTMLElement).style.boxShadow = 'none';
            }}
        >
            <Group gap="md" wrap="nowrap">
                <ThemeIcon size={42} radius="md" variant="light" color="neutral">
                    {icon}
                </ThemeIcon>
                <div>
                    <Text fw={700} size="sm">
                        {title}
                    </Text>
                    <Text size="xs" c="dimmed">
                        {subtitle}
                    </Text>
                </div>
            </Group>
        </UnstyledButton>
    );
};

export { GetStartedItem };
